'use client';

import { FC, PropsWithChildren } from 'react';

import { createCustomContext } from './context';
import { useProfileContext } from './ProfileProvider';

interface GTMData {
  event: string;
  ecommerce?: {
    [key: string]: unknown; // Описание для любых дополнительных данных в ecommerce
  };
  [key: string]: unknown; // Для других свойств, которые могут быть добавлены
}

const [Context, useGTMContext] = createCustomContext<(data: GTMData) => void>({
  name: 'GTMContext',
});
export { useGTMContext };

export const GTMProvider: FC<PropsWithChildren> = ({ children }) => {
  const profile = useProfileContext();

  const sendGTM = (data: GTMData) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      // Базовые данные для ecommerce
      const baseData = {
        user_id: profile?.id,
        type_user: profile?.isAcitveStartFunnel ? 'Стартовый' : 'Платящий',
      };

      window.dataLayer.push({
        ...data, // Сохраняем все свойства data (например, event)
        ...baseData,
      });

      if (process.env.NODE_ENV === 'development') {
        console.log('[SUCCESS] GTM data sent: ', {
          ...data,
        });
      }
    } else {
      console.warn('[ERROR] GTM dataLayer is not available');
    }
  };

  return <Context value={sendGTM}>{children}</Context>;
};
